import React, { useEffect, useRef, useState, useMemo } from "react"
import * as THREE from "three"
import {useSphere } from "@react-three/cannon"
import { useThree, useFrame } from "@react-three/fiber"
import useStore from "../StateStore/store"
import gsap, {Linear} from "gsap"

const SPEED = 50;
const keys = { ArrowUp: "forward", ArrowDown: "backward", ArrowLeft: "left", ArrowRight: "right", KeyA : "left", KeyD : "right", KeyW : "up", KeyS : "down"}
const moveFieldByKey = (key) => keys[key]
const direction = new THREE.Vector3()
const frontVector = new THREE.Vector3()
const sideVector = new THREE.Vector3()
const euler = new THREE.Euler(0, 0, 0, "YXZ")
const minPolarAngle = 0;
const maxPolarAngle = Math.PI;
const _PI_2 = Math.PI/2;
let moving = false
let a = 0

function lerp( start , end, amt ) {
	return ( 1 - amt ) * start  + amt * end;
}

function smoothstep (min, max, value) {
  var x = Math.max(0, Math.min(1, (value-min)/(max-min)));
  return x*x*(3 - 2*x);
};



const usePlayerControls = () => {
  const [movement, setMovement] = useState({ forward: false, backward: false, left: false, right: false, up : false, down : false})

  const {camera} = useThree()
  const propogation = useStore(state => state.propogateToStall)
  const setPan = useStore(state => state.pan.setPan)
  
  const handleMouseMove = (e) => {
   if(propogation.exitButton === false){
      if(e.buttons === 1){
      const movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
      const movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;

      euler.setFromQuaternion( camera.quaternion );

			euler.y -= movementX * 0.002;
			euler.x -= movementY * 0.002;

			euler.x = Math.max( _PI_2 - maxPolarAngle, Math.min( _PI_2 - minPolarAngle, euler.x ) );

			camera.quaternion.setFromEuler( euler );
      setPan(true)
    } else{
      setPan(false)
    }
   }
  }
 
  useEffect(() => {
    const handleKeyDown = (e) => setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: true }))
    const handleKeyUp = (e) => setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: false }))
    document.addEventListener("keydown", handleKeyDown)
    document.addEventListener("keyup", handleKeyUp)
    document.addEventListener("pointermove", handleMouseMove)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.removeEventListener("keyup", handleKeyUp)
      document.removeEventListener("pointermove", handleMouseMove)
    }
  }, [])
  return movement
}

const FirstPersonPrespective = (props) => {
  const [ref, api] = useSphere(() => ({ mass: 1, type: "Dynamic",  position : [0, 0, 0], rotation: [0, 0, 0],...props }))
  const blind = useRef()

  const teleportation = useStore(state => state.playerTeleport)
  const setTeleport = useStore(state => state.playerTeleport.setTeleport)
  let controllerState = useStore(state => state.touchController)

    const d = useMemo(() => new THREE.Vector3(), [])
    const d2 = useMemo(() => new THREE.Vector3(), [])

    const teleport = () => {
      if(teleportation.position){
        // let p = ref.current.position.lerp(teleportation.position, 0.01)
        // api.position.set(p.x, p.y, p.z)
        // console.log(Math.pow(1 - (30*3), 1*60))
        // let px = lerp(ref.current.position.x, teleportation.position.x,0.05)
        // let py = 5
        // let pz = lerp(ref.current.position.z, teleportation.position.z, 0.05)
        
        
        // if(camera.position.distanceTo(teleportation.position) <= 6){
        //   px = teleportation.position.x
        //   pz = teleportation.position.z
        // }
        // // if(camera.position.distanceTo(teleportation.position))
        // api.position.set( px, py, pz)

        // if(px === teleportation.position.x && pz === teleportation.position.z){
        //   setTeleport(false)
        // }
        d.set(teleportation.position.x, 0, teleportation.position.z)
        d2.lerp(d, 0.03)

        api.position.set(d2.x, d2.y, d2.z)

        if(camera.position.distanceTo(teleportation.position) <= 6){
          setTeleport(false)
        }
      }
    }
  

    // const direction = React.useMemo(() => new THREE.Vector3(), [])
    // const origin = React.useMemo(() => new THREE.Vector3(), [])
    // const target = React.useMemo(() => new THREE.Vector3(), [])

    // const teleport = () => {
    //   if(teleportation.position){
    //     let step = 0.5
    //     direction.copy(teleportation.position).sub(camera.position)
    //     .position.copy(origin)
    //     target.copy(teleportation.position)
    //     direction.copy(target).sub(origin)

    //     if(direction.length < 0.5){
    //       api.position.set(origin.x+direction.x, 5, origin.z+direction.z)
    //       return;
    //     }

    //     direction.normalize().multiplyScalar(step);
        
    //     api.position.set(origin.x+step, 5, origin.z+step)
    //     console.log(ref.current.position)
    //   }
    // }


    const propogation = useStore(state => state.propogateToStall)
    
    const propogate = React.useCallback(() => {
        blind.current.material.visible = true
        a+=0.03
        blind.current.material.opacity = lerp(blind.current.material.opacity, 1.3, 0.025)

        if(blind.current.material.opacity > 0.99){
          const r = propogation.position.z > 0 ? 1 : 0
          camera.position.set(propogation.position.x, 5, propogation.position.z)
            api.position.set(propogation.position.x, propogation.position.y, propogation.position.z)
            if(propogation.rotation){
              camera.rotation.set(0, Math.PI * r+propogation.rotation, 0)
            }else{
              camera.rotation.set(0, Math.PI * r, 0)
            }
        }
        
    }, [])

    let {forward, backward, left, right, up, down} = usePlayerControls()

    const { camera } = useThree()
 
    useEffect(() => {camera.rotation.set(0, 0, 0)}, [])
    const velocity = useRef([0, 0, 0])

    // console.log(api.position.x)

    useEffect(() => void api.velocity.subscribe((v) => (velocity.current = v)), [])
    useFrame(() => {
        blind.current.position.set(ref.current.position.x, 5, ref.current.position.z )
        if(teleportation.teleportState === true){
          teleport()
        }else{
          d2.set(camera.position.x, 0, camera.position.z )
        }

        if(propogation.propogateState === true){
          propogate()
          camera.position.set(ref.current.position.x, 5, ref.current.position.z)
        }else{
          blind.current.material.opacity = lerp(blind.current.material.opacity, -0.4, 0.01)
          if(blind.current.material.opacity < -0.1){
            blind.current.material.visible = false
          }
          if(propogation.exitButton === false){
            if(controllerState.buttonsActive === true){
              forward = controllerState.movementState.forward
              backward = controllerState.movementState.backward
              left = controllerState.movementState.left
              right = controllerState.movementState.right
            }
            
            // ref.current.getWorldPosition(camera.position);
            camera.position.set(ref.current.position.x, 5, ref.current.position.z)
            frontVector.set(0, 0, Number(backward) - Number(forward))
            euler.setFromQuaternion( camera.quaternion );
            euler.y += (Number(left)-Number(right)) * 0.01
            euler.x += (Number(up)-Number(down)) *0.01
            if(forward === true || backward === true ){
              euler.x = lerp(euler.x, 0, 0.03)
              euler.z = lerp(euler.z, 0, 0.03)
            }
            camera.quaternion.setFromEuler( euler );
            sideVector.set(0, 0, 0)
            direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED).applyEuler(camera.rotation)
            
            api.velocity.set(direction.x, velocity.current[1], direction.z)
          }
        } 

        
    })

    return (
      <>
        
        <mesh ref={ref}>
          {/* <sphereBufferGeometry args={[1, 60, 60]} />
          <meshBasicMaterial visible ={false} /> */}
        </mesh>
        <mesh ref={blind} >
            <boxBufferGeometry args={[1, 1, 1]} />
            <meshBasicMaterial color={"black"} side={THREE.DoubleSide} transparent />
        </mesh>
        
      </>
    )
    
}

export default FirstPersonPrespective
